export const assignmentsColumns = [
  {
    field: 'person.globalId',
    title: 'GlobalID',
    align: 'left',
    width: '100px',
    render: row => row.person?.globalId || ''
  },
  {
    field: 'globalId',
    title: 'Marca',
    align: 'left',
    width: '100px',
    render: row => row.globalId || ''
  },
  {
    field: 'person.firstName',
    title: 'Partner Name',
    align: 'left',
    disableSorting: true,
    render: row => `${row.person.firstName} ${row.person.lastName}`
  },
  {
    field: 'email',
    title: 'Email',
    align: 'left',
    collapsible: true,
    render: row => row.email
  },
  {
    field: 'person.phone',
    title: 'Phone',
    align: 'left',
    collapsible: true,
    render: row => row.person.phone
  },
  {
    field: 'delegate',
    title: 'Delegate',
    align: 'left',
    collapsible: true,
    disableSorting: true,
    render: row => (row.delegate ? `${row.delegate.firstName} ${row.delegate.lastName}` : '')
  },
  {
    field: 'externalPartnerType.name',
    title: 'Type',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => row.externalPartnerType.name
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => row.status.name
  }
]

export const delegatesColumns = [
  { field: 'firstName', title: 'First Name', align: 'left' },
  { field: 'lastName', title: 'Last Name', align: 'left' },
  { field: 'email', title: 'Email', align: 'left', collapsible: true },
  { field: 'phone', title: 'Phone', align: 'left', collapsible: true },
  {
    field: 'activeAssignmentsCount',
    title: 'Assignments',
    align: 'left',
    collapsible: true,
    disableSorting: true,
    width: '180px',
    render: row => row.activeAssignmentsCount || 'No active assignments'
  },
  {
    field: 'isEnabled',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => (row.isEnabled ? 'Enabled' : 'Disabled')
  }
]
